import { render } from "./QrCodeRender.vue?vue&type=template&id=a1b58272&ts=true"
import script from "./QrCodeRender.vue?vue&type=script&lang=ts"
export * from "./QrCodeRender.vue?vue&type=script&lang=ts"

import "./QrCodeRender.vue?vue&type=style&index=0&id=a1b58272&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/HeThongPVNB/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__